import { Component } from "@angular/core";
import { State } from '@progress/kendo-data-query';
import { DataGridComponent } from '../core/data-grid.component';
import { ConnectionDataService } from './services/connection-data.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: "app-service-bus",
  templateUrl: "./service-bus.component.html",
  styleUrls: ["./service-bus.component.scss"],
})
export class ServiceBusComponent extends DataGridComponent {

  public gridState: State = {
    sort: [
      {
        field: "Namespace",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  };
    
  constructor(
    private dataService: ConnectionDataService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, "")
      .pipe(tap(() => (this.loading = false)));
  }
}
